// EN · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "What's new in WA Checkin",
  "kicker": "What's new",
  "stepOf": "Step {n} of {total}",
  "close": "Close",
  "dontShow": "Don't show again",
  "prev": "Back",
  "next": "Next",
  "done": "Got it",
  "steps": {
    "icons": {
      "title": "Icons on your bookings",
      "text": "Every booking in the calendar and in the bookings list now shows small icons: AI reception requests, calls, notes and whether money is still owed. Hover over them to see the details without opening the booking.",
      "cta": ""
    },
    "early": {
      "title": "Charge for early check-in",
      "text": "Early check-in can now have a price. The AI agent asks for the arrival time, works out the cost and sends the payment link. Once paid, it is confirmed automatically.",
      "cta": "Set it up in AI Agent"
    },
    "reception": {
      "title": "AI Reception",
      "text": "Everything your guests ask the agent for (early check-in, late checkout, extra nights, invoices, call messages) lands in one inbox. Approve, reject or prioritise with one click and see the amount of anything that is charged.",
      "cta": "Open AI Reception"
    },
    "translate": {
      "title": "Real-time translation",
      "text": "In each booking's chat and in the inbox, switch on translation: what the guest writes reaches you in your language, and when you press Enter you first see your message translated into theirs before it is sent.",
      "cta": "Go to messages"
    },
    "voice": {
      "title": "Voice calls with the AI agent",
      "text": "Turn on phone reception: the AI agent answers calls in the caller's language, solves questions, sends the booking link and leaves you a summary of every call.",
      "cta": "Turn on voice calls"
    }
  },
  "demo": {
    "iconsTipTitle": "AI reception",
    "iconsTipEarly": "Early check-in",
    "iconsTipPending": "Pending:",
    "paid": "Paid",
    "earlyGuest": "Can we check in at 11:00?",
    "earlyAgent": "Yes! Early check-in at 11:00 costs €30. You can pay here:",
    "earlyPaid": "Paid · confirmed",
    "rx": {
      "early": "Early check-in",
      "late": "Late checkout",
      "extend": "Extend stay"
    },
    "pending": "Pending",
    "confirmed": "Confirmed",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "¿A qué hora podemos recoger las llaves?",
    "trMine": "A partir de las 15:00, te esperamos",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Call summary",
    "voiceSummary": "Asked about parking and booked 2 nights. Booking link sent by WhatsApp."
  }
};
